import * as React from 'react';
import SearchCondition from "./components/SearchCondition";
import {useEffect, useState} from "react";
import {WeChatMessageTemplateSearchCondition} from "../../../../modules/wechat/dto/WeChatMessageTemplateSearchCondition";
import {WeChatMessageTemplateDto} from "../../../../modules/wechat/dto/WeChatMessageTemplateDto";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import {WeChatMessageTemplateApi} from "../../../../modules/wechat/api/WeChatMessageTemplateApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {useIntl} from "react-intl";
import SearchResult from "./components/SearchResult";
import MessageTemplateDetailDialog from "./components/MessageTemplateDetailDialog";
import PaginationBar from "../../../../components/PaginationBar";
import {Paper} from "@mui/material";
import {WeChatApplicationDto} from "../../../../modules/wechat/dto/WeChatApplicationDto";
import {WeChatApplicationApi} from "../../../../modules/wechat/api/WeChatApplicationApi";

export default function Index() {
    const intl = useIntl();

    const [wechatApplicationList, setWechatApplicationList] = useState<Array<WeChatApplicationDto>>([]);

    const _fetchWechatApplicationList = async () => {
        const responseResult = await WeChatApplicationApi.getWeChatApplicationList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setWechatApplicationList(responseResult.data);
        }
    };

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new WeChatMessageTemplateSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<WeChatMessageTemplateDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const [openDetailDialog, setOpenDetailDialog] = useState(false);

    const [currentRow, setCurrentRow] = useState<WeChatMessageTemplateDto>(new WeChatMessageTemplateDto());

    useEffect(() => {
        _fetchWechatApplicationList();
        _handleSearch(searchCondition);
    }, []);


    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const _handleSearch = async (searchCondition: WeChatMessageTemplateSearchCondition) => {
        const responseResult = await WeChatMessageTemplateApi.queryMessageTemplates(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const _handleClickModify = async (record: WeChatMessageTemplateDto) => {
        const responseResult = await WeChatMessageTemplateApi.getMessageTemplateDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailDialog(true);
        }
    };

    const _handleClickDelete = async (record: WeChatMessageTemplateDto) => {
        const responseResult = await WeChatMessageTemplateApi.deleteMessageTemplate(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
            _handleSearch(searchCondition);
        }
    };

    const _handleClickAdd = () => {
        setCurrentRow(new WeChatMessageTemplateDto());
        setOpenDetailDialog(true);
    };

    const _handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        _handleSearch(newSearchCondition);
    };

    return (
        <div>
            <MessageTemplateDetailDialog open={openDetailDialog} wechatApplicationList={wechatApplicationList}
                                         wechatMessageTemplate={currentRow}
                                         onClose={() => setOpenDetailDialog(false)} onOk={() => _handleSearch(searchCondition)}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={handleChangeCondition}
                                 onClickSearch={() => _handleSearch(searchCondition)}
                                 onClickAdd={_handleClickAdd}/>
            </Paper>
            <br/>

            <Paper sx={{p: 1}}>
                <PaginationBar pagination={pagination} onChange={_handlePagination}/>
                <br/>
                <SearchResult searchResult={searchResult}
                              onClickDelete={(record) => _handleClickDelete(record)}
                              onClickModify={(record) => _handleClickModify(record)}/>
            </Paper>
        </div>
    );
}